/** @format */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap.js';
//import '../css/app.css';
import './version.js';

// Import Quill CSS
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

import Vue from 'vue';
//import Vue from 'vue/dist/vue.esm.js';
import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText
} from './font-awesome.js';

import { clientMixin } from './mixins/ClientMixin.js';
import { errorMixin } from './mixins/ErrorMixin.js';
import { publicationMixin } from './mixins/PublicationMixin.js';
import { userMixin } from './mixins/UserMixin.js';
import App from './components/Root/App.vue';
import ShowError from './components/Common/Error.vue';
import ShowSuccess from './components/Common/Success.vue';
import CardModal from './components/Common/Modal/Card.vue';
import StandardModal from './components/Common/Modal/Standard.vue';
import Field from './components/Common/BasicField.vue';
import HorizontalField from './components/Common/HorizontalField.vue';
import BusyLoader from './components/Common/BusyLoader.vue';
import vClickOutside from 'v-click-outside';
import VueRouter from 'vue-router';
import VueSweetAlert from 'vue-sweetalert';
import VueClipboard from 'vue-clipboard2';
import Vuex from 'vuex';
import store from './store/index.js';
import router from './router/index.js';
import VueMeta from 'vue-meta';
import VueGtag from 'vue-gtag';

/*
if (process.env.NODE_ENV === 'production') {
    // Disable vue devtools, debug in production mode
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}
*/

Vue.use(Vuex);
Vue.use(VueMeta);
Vue.use(VueRouter);
//if (process.env.NODE_ENV === 'production') {
    Vue.use(
        VueGtag,
        {
            config: {
                id: 'G-CEHRJ2XKZH' // UA-104540283-1
            },
            bootstrap: true
        },
        router
    );
//}
Vue.use(VueSweetAlert);
Vue.use(VueClipboard);
Vue.use(vClickOutside);
Vue.component('BusyLoader', BusyLoader); // Register BusyLoader as a global component
Vue.component('CardModal', CardModal);
Vue.component('StandardModal', StandardModal);
Vue.component('Field', Field);
Vue.component('HorizontalField', HorizontalField);
Vue.component('FaIcon', FontAwesomeIcon);
Vue.component('FaLayers', FontAwesomeLayers);
Vue.component('FaLayersText', FontAwesomeLayersText);

Vue.mixin(clientMixin);
Vue.mixin(errorMixin);
Vue.mixin(publicationMixin);
Vue.mixin(userMixin);

store.commit(
    'viewer/setPreferences',
    JSON.parse(window.naShared.storage.getItem('ignorePreferences')) ?? true
);

window.loadRecaptchaApi = function () {
    store.commit('app/setRecaptchaLoaded', true);
};

window.loadGoogleApi = function loadGoogleApi() {
    // Wait for Google Identity Services to be fully loaded
    const initGoogleAuth = () => {
        if (window.google && window.google.accounts && window.google.accounts.id) {
            const clientId = document.querySelector('meta[name="google-signin-client_id"]')?.content;
            console.log('Google client ID found:', clientId);
            console.log('Current origin:', window.location.origin);
            if (clientId) {
                try {
                    // Check if already initialized to avoid re-initialization issues
                    if (window.google.accounts.id._clientId && window.google.accounts.id._clientId !== clientId) {
                        console.warn('Google Identity Services already initialized with different client ID:', {
                            existing: window.google.accounts.id._clientId,
                            new: clientId
                        });
                    } else if (!window.google.accounts.id._clientId) {
                        window.google.accounts.id.initialize({
                            client_id: clientId,
                            callback: window.handleCredentialResponse
                        });
                        console.log('Google Identity Services initialized successfully with client ID:', clientId);
                    } else {
                        console.log('Google Identity Services already initialized with client ID:', window.google.accounts.id._clientId);
                    }
                    store.commit('app/setGoogleAuthClientLoaded', true);
                } catch (error) {
                    console.error('Error initializing Google Identity Services:', error);
                    console.error('This may be due to origin configuration. Please verify that:', {
                        origin: window.location.origin,
                        clientId: clientId,
                        message: 'Add the origin to Authorized JavaScript origins in Google Cloud Console'
                    });
                    // Still set as loaded to prevent infinite retries, but log the error
                    store.commit('app/setGoogleAuthClientLoaded', true);
                }
            } else {
                console.error('Google client ID not found in meta tag');
            }
        } else {
            // Retry after a short delay if Google API isn't ready yet
            setTimeout(initGoogleAuth, 100);
        }
    };
    
    initGoogleAuth();
};

// Global callback function for Google Identity Services
window.handleCredentialResponse = function(response) {
    // This will be called when the user signs in
    // The response.credential contains the JWT token
    console.log('Google credential response received:', response);
    window.googleCredentialResponse = response;
    
    // If there's a pending sign-in promise, resolve it
    if (window.googleSignInResolve && window.googleSignInTimeout) {
        clearTimeout(window.googleSignInTimeout);
        window.googleSignInResolve(response);
        // Clean up
        window.googleSignInResolve = null;
        window.googleSignInReject = null;
        window.googleSignInTimeout = null;
        
        // Clean up any temporary divs
        const tempDivs = document.querySelectorAll('div[style*="-9999px"]');
        tempDivs.forEach(div => {
            if (document.body.contains(div)) {
                document.body.removeChild(div);
            }
        });
    }
};

const app = new Vue({
    el: '#app',
    store,
    router,
    components: {
        App,
        ShowError,
        ShowSuccess
    },
    created() {
        store.dispatch('tracking/initParametersFromUrl');
    }
});

if (import.meta.env.MODE !== 'production') {
    window.app = app;
}
